export const stateCode = [
  {
    id: 3,
    code: "AL",
    state: "Alabama",
    countryId: 0,
    country: "US",
  },
  {
    id: 2,
    code: "AK",
    state: "Alaska",
    countryId: 0,
    country: "US",
  },
  {
    id: 803,
    code: "AS",
    state: "American Samoa",
    countryId: 0,
    country: "US",
  },
  {
    id: 5,
    code: "AZ",
    state: "Arizona",
    countryId: 0,
    country: "US",
  },
  {
    id: 4,
    code: "AR",
    state: "Arkansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 6,
    code: "CA",
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 7,
    code: "CO",
    state: "Colorado",
    countryId: 0,
    country: "US",
  },
  {
    id: 8,
    code: "CT",
    state: "Connecticut",
    countryId: 0,
    country: "US",
  },
  {
    id: 10,
    code: "DE",
    state: "Delaware",
    countryId: 0,
    country: "US",
  },
  {
    id: 11,
    code: "FL",
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 12,
    code: "GA",
    state: "Georgia",
    countryId: 0,
    country: "US",
  },
  {
    id: 802,
    code: "GU",
    state: "Guam",
    countryId: 0,
    country: "US",
  },
  {
    id: 539,
    code: "HI",
    state: "Hawaii",
    countryId: 0,
    country: "US",
  },
  {
    id: 14,
    code: "ID",
    state: "Idaho",
    countryId: 0,
    country: "US",
  },
  {
    id: 15,
    code: "IL",
    state: "Illinois",
    countryId: 0,
    country: "US",
  },
  {
    id: 16,
    code: "IN",
    state: "Indiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 13,
    code: "IA",
    state: "Iowa",
    countryId: 0,
    country: "US",
  },
  {
    id: 17,
    code: "KS",
    state: "Kansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 18,
    code: "KY",
    state: "Kentucky",
    countryId: 0,
    country: "US",
  },
  {
    id: 19,
    code: "LA",
    state: "Louisiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 22,
    code: "ME",
    state: "Maine",
    countryId: 0,
    country: "US",
  },
  {
    id: 21,
    code: "MD",
    state: "Maryland",
    countryId: 0,
    country: "US",
  },
  {
    id: 20,
    code: "MA",
    state: "Massachusetts",
    countryId: 0,
    country: "US",
  },
  {
    id: 23,
    code: "MI",
    state: "Michigan",
    countryId: 0,
    country: "US",
  },
  {
    id: 24,
    code: "MN",
    state: "Minnesota",
    countryId: 0,
    country: "US",
  },
  {
    id: 26,
    code: "MS",
    state: "Mississippi",
    countryId: 0,
    country: "US",
  },
  {
    id: 25,
    code: "MO",
    state: "Missouri",
    countryId: 0,
    country: "US",
  },
  {
    id: 27,
    code: "MT",
    state: "Montana",
    countryId: 0,
    country: "US",
  },
  {
    id: 30,
    code: "NE",
    state: "Nebraska",
    countryId: 0,
    country: "US",
  },
  {
    id: 34,
    code: "NV",
    state: "Nevada",
    countryId: 0,
    country: "US",
  },
  {
    id: 31,
    code: "NH",
    state: "New Hampshire",
    countryId: 0,
    country: "US",
  },
  {
    id: 32,
    code: "NJ",
    state: "New Jersey",
    countryId: 0,
    country: "US",
  },
  {
    id: 33,
    code: "NM",
    state: "New Mexico",
    countryId: 0,
    country: "US",
  },
  {
    id: 35,
    code: "NY",
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 28,
    code: "NC",
    state: "North Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 29,
    code: "ND",
    state: "North Dakota",
    countryId: 0,
    country: "US",
  },
  {
    id: 804,
    code: "MP",
    state: "Northern Mariana Islands",
    countryId: 0,
    country: "US",
  },
  {
    id: 36,
    code: "OH",
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 37,
    code: "OK",
    state: "Oklahoma",
    countryId: 0,
    country: "US",
  },
  {
    id: 38,
    code: "OR",
    state: "Oregon",
    countryId: 0,
    country: "US",
  },
  {
    id: 39,
    code: "PA",
    state: "Pennsylvania",
    countryId: 0,
    country: "US",
  },
  {
    id: 801,
    code: "PR",
    state: "Puerto Rico",
    countryId: 0,
    country: "US",
  },
  {
    id: 40,
    code: "RI",
    state: "Rhode Island",
    countryId: 0,
    country: "US",
  },
  {
    id: 41,
    code: "SC",
    state: "South Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 42,
    code: "SD",
    state: "South Dakota",
    countryId: 0,
    country: "US",
  },
  {
    id: 43,
    code: "TN",
    state: "Tennessee",
    countryId: 0,
    country: "US",
  },
  {
    id: 44,
    code: "TX",
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 45,
    code: "UT",
    state: "Utah",
    countryId: 0,
    country: "US",
  },
  {
    id: 47,
    code: "VT",
    state: "Vermont",
    countryId: 0,
    country: "US",
  },
  {
    id: 799,
    code: "VI",
    state: "Virgin Islands",
    countryId: 0,
    country: "US",
  },
  {
    id: 46,
    code: "VA",
    state: "Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 48,
    code: "WA",
    state: "Washington",
    countryId: 0,
    country: "US",
  },
  {
    id: 9,
    code: "DC",
    state: "Washington D.C.",
    countryId: 0,
    country: "US",
  },
  {
    id: 50,
    code: "WV",
    state: "West Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 49,
    code: "WI",
    state: "Wisconsin",
    countryId: 0,
    country: "US",
  },
  {
    id: 51,
    code: "WY",
    state: "Wyoming",
    countryId: 0,
    country: "US",
  },
]

export const dmaCode = [
  {
    id: 662,
    dma: "Abilene-Sweetwater",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 525,
    dma: "Albany",
    stateCode: "GA",
    stateId: 12,
    state: "Georgia",
    countryId: 0,
    country: "US",
  },
  {
    id: 532,
    dma: "Albany et al",
    stateCode: "NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 790,
    dma: "Albuquerque-Santa Fe",
    stateCode: "NM",
    stateId: 33,
    state: "New Mexico",
    countryId: 0,
    country: "US",
  },
  {
    id: 644,
    dma: "Alexandria",
    stateCode: "LA",
    stateId: 19,
    state: "Louisiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 583,
    dma: "Alpena",
    stateCode: "MI",
    stateId: 23,
    state: "Michigan",
    countryId: 0,
    country: "US",
  },
  {
    id: 634,
    dma: "Amarillo",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 743,
    dma: "Anchorage",
    stateCode: "AK",
    stateId: 2,
    state: "Alaska",
    countryId: 0,
    country: "US",
  },
  {
    id: 524,
    dma: "Atlanta",
    stateCode: "GA",
    stateId: 12,
    state: "Georgia",
    countryId: 0,
    country: "US",
  },
  {
    id: 520,
    dma: "Augusta-Aiken",
    stateCode: "GA-SC",
    stateId: 41,
    state: "South Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 635,
    dma: "Austin",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 800,
    dma: "Bakersfield",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 512,
    dma: "Baltimore",
    stateCode: "MD",
    stateId: 21,
    state: "Maryland",
    countryId: 0,
    country: "US",
  },
  {
    id: 537,
    dma: "Bangor",
    stateCode: "ME",
    stateId: 22,
    state: "Maine",
    countryId: 0,
    country: "US",
  },
  {
    id: 716,
    dma: "Baton Rouge",
    stateCode: "LA",
    stateId: 19,
    state: "Louisiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 692,
    dma: "Beaumont-Port Arthur",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 821,
    dma: "Bend",
    stateCode: "OR",
    stateId: 38,
    state: "Oregon",
    countryId: 0,
    country: "US",
  },
  {
    id: 756,
    dma: "Billings",
    stateCode: "MT",
    stateId: 27,
    state: "Montana",
    countryId: 0,
    country: "US",
  },
  {
    id: 746,
    dma: "Biloxi-Gulfport",
    stateCode: "MS",
    stateId: 26,
    state: "Mississippi",
    countryId: 0,
    country: "US",
  },
  {
    id: 502,
    dma: "Binghamton",
    stateCode: "NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 630,
    dma: "Birmingham et al",
    stateCode: "AL",
    stateId: 3,
    state: "Alabama",
    countryId: 0,
    country: "US",
  },
  {
    id: 559,
    dma: "Bluefield et al",
    stateCode: "WV",
    stateId: 50,
    state: "West Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 757,
    dma: "Boise",
    stateCode: "ID",
    stateId: 14,
    state: "Idaho",
    countryId: 0,
    country: "US",
  },
  {
    id: 506,
    dma: "Boston et al",
    stateCode: "MA-NH",
    stateId: 31,
    state: "New Hampshire",
    countryId: 0,
    country: "US",
  },
  {
    id: 736,
    dma: "Bowling Green",
    stateCode: "KY",
    stateId: 18,
    state: "Kentucky",
    countryId: 0,
    country: "US",
  },
  {
    id: 514,
    dma: "Buffalo",
    stateCode: "NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 523,
    dma: "Burlington et al",
    stateCode: "VT-NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 754,
    dma: "Butte-Bozeman",
    stateCode: "MT",
    stateId: 27,
    state: "Montana",
    countryId: 0,
    country: "US",
  },
  {
    id: 767,
    dma: "Casper-Riverton",
    stateCode: "WY",
    stateId: 51,
    state: "Wyoming",
    countryId: 0,
    country: "US",
  },
  {
    id: 637,
    dma: "Cedar Rapids et al",
    stateCode: "IA",
    stateId: 13,
    state: "Iowa",
    countryId: 0,
    country: "US",
  },
  {
    id: 648,
    dma: "Champaign et al",
    stateCode: "IL",
    stateId: 15,
    state: "Illinois",
    countryId: 0,
    country: "US",
  },
  {
    id: 519,
    dma: "Charleston",
    stateCode: "SC",
    stateId: 41,
    state: "South Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 564,
    dma: "Charleston et al",
    stateCode: "WV",
    stateId: 50,
    state: "West Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 517,
    dma: "Charlotte",
    stateCode: "NC",
    stateId: 28,
    state: "North Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 584,
    dma: "Charlottesville",
    stateCode: "VA",
    stateId: 46,
    state: "Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 575,
    dma: "Chattanooga",
    stateCode: "TN",
    stateId: 43,
    state: "Tennessee",
    countryId: 0,
    country: "US",
  },
  {
    id: 759,
    dma: "Cheyenne et al",
    stateCode: "WY-NE",
    stateId: 30,
    state: "Nebraska",
    countryId: 0,
    country: "US",
  },
  {
    id: 602,
    dma: "Chicago",
    stateCode: "IL",
    stateId: 15,
    state: "Illinois",
    countryId: 0,
    country: "US",
  },
  {
    id: 868,
    dma: "Chico-Redding",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 515,
    dma: "Cincinnati",
    stateCode: "OH",
    stateId: 36,
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 598,
    dma: "Clarksburg-Weston",
    stateCode: "WV",
    stateId: 50,
    state: "West Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 510,
    dma: "Cleveland et al",
    stateCode: "OH",
    stateId: 36,
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 752,
    dma: "Colorado Sprgs et al",
    stateCode: "CO",
    stateId: 7,
    state: "Colorado",
    countryId: 0,
    country: "US",
  },
  {
    id: 546,
    dma: "Columbia",
    stateCode: "SC",
    stateId: 41,
    state: "South Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 604,
    dma: "Columbia et al",
    stateCode: "MO",
    stateId: 25,
    state: "Missouri",
    countryId: 0,
    country: "US",
  },
  {
    id: 535,
    dma: "Columbus",
    stateCode: "OH",
    stateId: 36,
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 522,
    dma: "Columbus et al",
    stateCode: "GA-AL",
    stateId: 3,
    state: "Alabama",
    countryId: 0,
    country: "US",
  },
  {
    id: 673,
    dma: "Columbus et al",
    stateCode: "MS",
    stateId: 26,
    state: "Mississippi",
    countryId: 0,
    country: "US",
  },
  {
    id: 600,
    dma: "Corpus Christi",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 623,
    dma: "Dallas-Ft. Worth",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 682,
    dma: "Davenport et al",
    stateCode: "IA-IL",
    stateId: 15,
    state: "Illinois",
    countryId: 0,
    country: "US",
  },
  {
    id: 542,
    dma: "Dayton",
    stateCode: "OH",
    stateId: 36,
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 751,
    dma: "Denver",
    stateCode: "CO",
    stateId: 7,
    state: "Colorado",
    countryId: 0,
    country: "US",
  },
  {
    id: 679,
    dma: "Des Moines-Ames",
    stateCode: "IA",
    stateId: 13,
    state: "Iowa",
    countryId: 0,
    country: "US",
  },
  {
    id: 505,
    dma: "Detroit",
    stateCode: "MI",
    stateId: 23,
    state: "Michigan",
    countryId: 0,
    country: "US",
  },
  {
    id: 606,
    dma: "Dothan",
    stateCode: "AL",
    stateId: 3,
    state: "Alabama",
    countryId: 0,
    country: "US",
  },
  {
    id: 676,
    dma: "Duluth-Superior",
    stateCode: "MN-WI",
    stateId: 49,
    state: "Wisconsin",
    countryId: 0,
    country: "US",
  },
  {
    id: 765,
    dma: "El Paso et al",
    stateCode: "TX-NM",
    stateId: 33,
    state: "New Mexico",
    countryId: 0,
    country: "US",
  },
  {
    id: 565,
    dma: "Elmira et al",
    stateCode: "NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 516,
    dma: "Erie",
    stateCode: "PA",
    stateId: 39,
    state: "Pennsylvania",
    countryId: 0,
    country: "US",
  },
  {
    id: 801,
    dma: "Eugene",
    stateCode: "OR",
    stateId: 38,
    state: "Oregon",
    countryId: 0,
    country: "US",
  },
  {
    id: 802,
    dma: "Eureka",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 649,
    dma: "Evansville",
    stateCode: "IN",
    stateId: 16,
    state: "Indiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 745,
    dma: "Fairbanks",
    stateCode: "AK",
    stateId: 2,
    state: "Alaska",
    countryId: 0,
    country: "US",
  },
  {
    id: 724,
    dma: "Fargo-Valley City",
    stateCode: "ND",
    stateId: 29,
    state: "North Dakota",
    countryId: 0,
    country: "US",
  },
  {
    id: 513,
    dma: "Flint-Saginaw et al",
    stateCode: "MI",
    stateId: 23,
    state: "Michigan",
    countryId: 0,
    country: "US",
  },
  {
    id: 866,
    dma: "Fresno-Visalia",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 571,
    dma: "Ft. Myers-Naples",
    stateCode: "FL",
    stateId: 11,
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 670,
    dma: "Ft. Smith et al",
    stateCode: "AR",
    stateId: 4,
    state: "Arkansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 509,
    dma: "Ft. Wayne",
    stateCode: "IN",
    stateId: 16,
    state: "Indiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 592,
    dma: "Gainesville",
    stateCode: "FL",
    stateId: 11,
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 798,
    dma: "Glendive",
    stateCode: "MT",
    stateId: 27,
    state: "Montana",
    countryId: 0,
    country: "US",
  },
  {
    id: 773,
    dma: "Grand Junction et al",
    stateCode: "CO",
    stateId: 7,
    state: "Colorado",
    countryId: 0,
    country: "US",
  },
  {
    id: 563,
    dma: "Grand Rapids et al",
    stateCode: "MI",
    stateId: 23,
    state: "Michigan",
    countryId: 0,
    country: "US",
  },
  {
    id: 755,
    dma: "Great Falls",
    stateCode: "MT",
    stateId: 27,
    state: "Montana",
    countryId: 0,
    country: "US",
  },
  {
    id: 658,
    dma: "Green Bay-Appleton",
    stateCode: "WI",
    stateId: 49,
    state: "Wisconsin",
    countryId: 0,
    country: "US",
  },
  {
    id: 518,
    dma: "Greensboro et al",
    stateCode: "NC",
    stateId: 28,
    state: "North Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 545,
    dma: "Greenville et al",
    stateCode: "NC",
    stateId: 28,
    state: "North Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 567,
    dma: "Greenville et al",
    stateCode: "SC-NC",
    stateId: 28,
    state: "North Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 647,
    dma: "Greenwood-Greenville",
    stateCode: "MS",
    stateId: 26,
    state: "Mississippi",
    countryId: 0,
    country: "US",
  },
  {
    id: 636,
    dma: "Harlingen et al",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 566,
    dma: "Harrisburg et al",
    stateCode: "PA",
    stateId: 39,
    state: "Pennsylvania",
    countryId: 0,
    country: "US",
  },
  {
    id: 569,
    dma: "Harrisonburg",
    stateCode: "VA",
    stateId: 46,
    state: "Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 533,
    dma: "Hartford & New Haven",
    stateCode: "CT",
    stateId: 8,
    state: "Connecticut",
    countryId: 0,
    country: "US",
  },
  {
    id: 710,
    dma: "Hattiesburg-Laurel",
    stateCode: "MS",
    stateId: 26,
    state: "Mississippi",
    countryId: 0,
    country: "US",
  },
  {
    id: 766,
    dma: "Helena",
    stateCode: "MT",
    stateId: 27,
    state: "Montana",
    countryId: 0,
    country: "US",
  },
  {
    id: 744,
    dma: "Honolulu",
    stateCode: "HI",
    stateId: 539,
    state: "Hawaii",
    countryId: 0,
    country: "US",
  },
  {
    id: 618,
    dma: "Houston",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 691,
    dma: "Huntsville et al",
    stateCode: "AL",
    stateId: 3,
    state: "Alabama",
    countryId: 0,
    country: "US",
  },
  {
    id: 758,
    dma: "Idaho Falls et al",
    stateCode: "ID-WY",
    stateId: 51,
    state: "Wyoming",
    countryId: 0,
    country: "US",
  },
  {
    id: 527,
    dma: "Indianapolis",
    stateCode: "IN",
    stateId: 16,
    state: "Indiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 718,
    dma: "Jackson",
    stateCode: "MS",
    stateId: 26,
    state: "Mississippi",
    countryId: 0,
    country: "US",
  },
  {
    id: 639,
    dma: "Jackson",
    stateCode: "TN",
    stateId: 43,
    state: "Tennessee",
    countryId: 0,
    country: "US",
  },
  {
    id: 561,
    dma: "Jacksonville",
    stateCode: "FL",
    stateId: 11,
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 574,
    dma: "Johnstown et al",
    stateCode: "PA",
    stateId: 39,
    state: "Pennsylvania",
    countryId: 0,
    country: "US",
  },
  {
    id: 734,
    dma: "Jonesboro",
    stateCode: "AR",
    stateId: 4,
    state: "Arkansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 603,
    dma: "Joplin-Pittsburg",
    stateCode: "MO-KS",
    stateId: 17,
    state: "Kansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 747,
    dma: "Juneau",
    stateCode: "AK",
    stateId: 2,
    state: "Alaska",
    countryId: 0,
    country: "US",
  },
  {
    id: 616,
    dma: "Kansas City",
    stateCode: "MO-KS",
    stateId: 17,
    state: "Kansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 557,
    dma: "Knoxville",
    stateCode: "TN",
    stateId: 43,
    state: "Tennessee",
    countryId: 0,
    country: "US",
  },
  {
    id: 702,
    dma: "La Crosse-Eau Claire",
    stateCode: "WI",
    stateId: 49,
    state: "Wisconsin",
    countryId: 0,
    country: "US",
  },
  {
    id: 582,
    dma: "Lafayette",
    stateCode: "IN",
    stateId: 16,
    state: "Indiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 642,
    dma: "Lafayette",
    stateCode: "LA",
    stateId: 19,
    state: "Louisiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 643,
    dma: "Lake Charles",
    stateCode: "LA",
    stateId: 19,
    state: "Louisiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 551,
    dma: "Lansing",
    stateCode: "MI",
    stateId: 23,
    state: "Michigan",
    countryId: 0,
    country: "US",
  },
  {
    id: 749,
    dma: "Laredo",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 839,
    dma: "Las Vegas",
    stateCode: "NV",
    stateId: 34,
    state: "Nevada",
    countryId: 0,
    country: "US",
  },
  {
    id: 541,
    dma: "Lexington",
    stateCode: "KY",
    stateId: 18,
    state: "Kentucky",
    countryId: 0,
    country: "US",
  },
  {
    id: 558,
    dma: "Lima",
    stateCode: "OH",
    stateId: 36,
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 722,
    dma: "Lincoln et al",
    stateCode: "NE",
    stateId: 30,
    state: "Nebraska",
    countryId: 0,
    country: "US",
  },
  {
    id: 693,
    dma: "Little Rock et al",
    stateCode: "AR",
    stateId: 4,
    state: "Arkansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 803,
    dma: "Los Angeles",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 529,
    dma: "Louisville",
    stateCode: "KY",
    stateId: 18,
    state: "Kentucky",
    countryId: 0,
    country: "US",
  },
  {
    id: 651,
    dma: "Lubbock",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 503,
    dma: "Macon",
    stateCode: "GA",
    stateId: 12,
    state: "Georgia",
    countryId: 0,
    country: "US",
  },
  {
    id: 669,
    dma: "Madison",
    stateCode: "WI",
    stateId: 49,
    state: "Wisconsin",
    countryId: 0,
    country: "US",
  },
  {
    id: 737,
    dma: "Mankato",
    stateCode: "MN",
    stateId: 24,
    state: "Minnesota",
    countryId: 0,
    country: "US",
  },
  {
    id: 553,
    dma: "Marquette",
    stateCode: "MI",
    stateId: 23,
    state: "Michigan",
    countryId: 0,
    country: "US",
  },
  {
    id: 813,
    dma: "Medford et al",
    stateCode: "OR",
    stateId: 38,
    state: "Oregon",
    countryId: 0,
    country: "US",
  },
  {
    id: 640,
    dma: "Memphis",
    stateCode: "TN",
    stateId: 43,
    state: "Tennessee",
    countryId: 0,
    country: "US",
  },
  {
    id: 711,
    dma: "Meridian",
    stateCode: "MS",
    stateId: 26,
    state: "Mississippi",
    countryId: 0,
    country: "US",
  },
  {
    id: 528,
    dma: "Miami-Ft. Lauderdale",
    stateCode: "FL",
    stateId: 11,
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 617,
    dma: "Milwaukee",
    stateCode: "WI",
    stateId: 49,
    state: "Wisconsin",
    countryId: 0,
    country: "US",
  },
  {
    id: 613,
    dma: "Minneapolis-St. Paul",
    stateCode: "MN",
    stateId: 24,
    state: "Minnesota",
    countryId: 0,
    country: "US",
  },
  {
    id: 687,
    dma: "Minot et al",
    stateCode: "ND",
    stateId: 29,
    state: "North Dakota",
    countryId: 0,
    country: "US",
  },
  {
    id: 762,
    dma: "Missoula",
    stateCode: "MT",
    stateId: 27,
    state: "Montana",
    countryId: 0,
    country: "US",
  },
  {
    id: 686,
    dma: "Mobile et al",
    stateCode: "AL-FL",
    stateId: 11,
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 628,
    dma: "Monroe-El Dorado",
    stateCode: "LA-AR",
    stateId: 4,
    state: "Arkansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 828,
    dma: "Monterey-Salinas",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 698,
    dma: "Montgomery-Selma",
    stateCode: "AL",
    stateId: 3,
    state: "Alabama",
    countryId: 0,
    country: "US",
  },
  {
    id: 570,
    dma: "Myrtle Beach et al",
    stateCode: "SC",
    stateId: 41,
    state: "South Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 659,
    dma: "Nashville",
    stateCode: "TN",
    stateId: 43,
    state: "Tennessee",
    countryId: 0,
    country: "US",
  },
  {
    id: 622,
    dma: "New Orleans",
    stateCode: "LA",
    stateId: 19,
    state: "Louisiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 501,
    dma: "New York",
    stateCode: "NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 544,
    dma: "Norfolk et al",
    stateCode: "VA",
    stateId: 46,
    state: "Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 740,
    dma: "North Platte",
    stateCode: "NE",
    stateId: 30,
    state: "Nebraska",
    countryId: 0,
    country: "US",
  },
  {
    id: 633,
    dma: "Odessa-Midland",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 650,
    dma: "Oklahoma City",
    stateCode: "OK",
    stateId: 37,
    state: "Oklahoma",
    countryId: 0,
    country: "US",
  },
  {
    id: 652,
    dma: "Omaha",
    stateCode: "NE",
    stateId: 30,
    state: "Nebraska",
    countryId: 0,
    country: "US",
  },
  {
    id: 534,
    dma: "Orlando et al",
    stateCode: "FL",
    stateId: 11,
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 631,
    dma: "Ottumwa et al",
    stateCode: "IA-MO",
    stateId: 25,
    state: "Missouri",
    countryId: 0,
    country: "US",
  },
  {
    id: 632,
    dma: "Paducah et al",
    stateCode: "KY-MO-IL",
    stateId: 15,
    state: "Illinois",
    countryId: 0,
    country: "US",
  },
  {
    id: 804,
    dma: "Palm Springs",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 656,
    dma: "Panama City",
    stateCode: "FL",
    stateId: 11,
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 597,
    dma: "Parkersburg",
    stateCode: "WV",
    stateId: 50,
    state: "West Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 675,
    dma: "Peoria-Bloomington",
    stateCode: "IL",
    stateId: 15,
    state: "Illinois",
    countryId: 0,
    country: "US",
  },
  {
    id: 504,
    dma: "Philadelphia",
    stateCode: "PA",
    stateId: 39,
    state: "Pennsylvania",
    countryId: 0,
    country: "US",
  },
  {
    id: 753,
    dma: "Phoenix et al",
    stateCode: "AZ",
    stateId: 5,
    state: "Arizona",
    countryId: 0,
    country: "US",
  },
  {
    id: 508,
    dma: "Pittsburgh",
    stateCode: "PA",
    stateId: 39,
    state: "Pennsylvania",
    countryId: 0,
    country: "US",
  },
  {
    id: 820,
    dma: "Portland",
    stateCode: "OR",
    stateId: 38,
    state: "Oregon",
    countryId: 0,
    country: "US",
  },
  {
    id: 500,
    dma: "Portland-Auburn",
    stateCode: "ME",
    stateId: 22,
    state: "Maine",
    countryId: 0,
    country: "US",
  },
  {
    id: 552,
    dma: "Presque Isle",
    stateCode: "ME",
    stateId: 22,
    state: "Maine",
    countryId: 0,
    country: "US",
  },
  {
    id: 521,
    dma: "Providence et al",
    stateCode: "RI-MA",
    stateId: 20,
    state: "Massachusetts",
    countryId: 0,
    country: "US",
  },
  {
    id: 717,
    dma: "Quincy et al",
    stateCode: "IL-MO-IA",
    stateId: 13,
    state: "Iowa",
    countryId: 0,
    country: "US",
  },
  {
    id: 560,
    dma: "Raleigh et al",
    stateCode: "NC",
    stateId: 28,
    state: "North Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 764,
    dma: "Rapid City",
    stateCode: "SD",
    stateId: 42,
    state: "South Dakota",
    countryId: 0,
    country: "US",
  },
  {
    id: 999,
    dma: "Remainder area not in any DMA",
    stateCode: 20,
    stateId: "Massachusetts",
    state: 0,
    countryId: "US",
    country: "",
  },
  {
    id: 811,
    dma: "Reno",
    stateCode: "NV",
    stateId: 34,
    state: "Nevada",
    countryId: 0,
    country: "US",
  },
  {
    id: 556,
    dma: "Richmond-Petersburg",
    stateCode: "VA",
    stateId: 46,
    state: "Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 573,
    dma: "Roanoke-Lynchburg",
    stateCode: "VA",
    stateId: 46,
    state: "Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 538,
    dma: "Rochester",
    stateCode: "NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 611,
    dma: "Rochester et al",
    stateCode: "MN-IA",
    stateId: 13,
    state: "Iowa",
    countryId: 0,
    country: "US",
  },
  {
    id: 610,
    dma: "Rockford",
    stateCode: "IL",
    stateId: 15,
    state: "Illinois",
    countryId: 0,
    country: "US",
  },
  {
    id: 862,
    dma: "Sacramento et al",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 576,
    dma: "Salisbury",
    stateCode: "MD",
    stateId: 21,
    state: "Maryland",
    countryId: 0,
    country: "US",
  },
  {
    id: 770,
    dma: "Salt Lake City",
    stateCode: "UT",
    stateId: 45,
    state: "Utah",
    countryId: 0,
    country: "US",
  },
  {
    id: 661,
    dma: "San Angelo",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 641,
    dma: "San Antonio",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 825,
    dma: "San Diego",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 807,
    dma: "San Francisco et al",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 855,
    dma: "Santa Barbara et al",
    stateCode: "CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 507,
    dma: "Savannah",
    stateCode: "GA",
    stateId: 12,
    state: "Georgia",
    countryId: 0,
    country: "US",
  },
  {
    id: 819,
    dma: "Seattle-Tacoma",
    stateCode: "WA",
    stateId: 48,
    state: "Washington",
    countryId: 0,
    country: "US",
  },
  {
    id: 657,
    dma: "Sherman-Ada",
    stateCode: "TX-OK",
    stateId: 37,
    state: "Oklahoma",
    countryId: 0,
    country: "US",
  },
  {
    id: 612,
    dma: "Shreveport",
    stateCode: "LA",
    stateId: 19,
    state: "Louisiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 624,
    dma: "Sioux City",
    stateCode: "IA",
    stateId: 13,
    state: "Iowa",
    countryId: 0,
    country: "US",
  },
  {
    id: 725,
    dma: "Sioux Falls et al",
    stateCode: "SD",
    stateId: 42,
    state: "South Dakota",
    countryId: 0,
    country: "US",
  },
  {
    id: 588,
    dma: "South Bend-Elkhart",
    stateCode: "IN",
    stateId: 16,
    state: "Indiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 881,
    dma: "Spokane",
    stateCode: "WA",
    stateId: 48,
    state: "Washington",
    countryId: 0,
    country: "US",
  },
  {
    id: 619,
    dma: "Springfield",
    stateCode: "MO",
    stateId: 25,
    state: "Missouri",
    countryId: 0,
    country: "US",
  },
  {
    id: 543,
    dma: "Springfield-Holyoke",
    stateCode: "MA",
    stateId: 20,
    state: "Massachusetts",
    countryId: 0,
    country: "US",
  },
  {
    id: 638,
    dma: "St. Joseph",
    stateCode: "MO",
    stateId: 25,
    state: "Missouri",
    countryId: 0,
    country: "US",
  },
  {
    id: 609,
    dma: "St. Louis",
    stateCode: "MO",
    stateId: 25,
    state: "Missouri",
    countryId: 0,
    country: "US",
  },
  {
    id: 555,
    dma: "Syracuse",
    stateCode: "NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 530,
    dma: "Tallahassee et al",
    stateCode: "FL-GA",
    stateId: 12,
    state: "Georgia",
    countryId: 0,
    country: "US",
  },
  {
    id: 539,
    dma: "Tampa et al",
    stateCode: "FL",
    stateId: 11,
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 581,
    dma: "Terre Haute",
    stateCode: "IN",
    stateId: 16,
    state: "Indiana",
    countryId: 0,
    country: "US",
  },
  {
    id: 547,
    dma: "Toledo",
    stateCode: "OH",
    stateId: 36,
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 605,
    dma: "Topeka",
    stateCode: "KS",
    stateId: 17,
    state: "Kansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 540,
    dma: "Traverse City et al",
    stateCode: "MI",
    stateId: 23,
    state: "Michigan",
    countryId: 0,
    country: "US",
  },
  {
    id: 531,
    dma: "Tri-Cities",
    stateCode: "TN-VA",
    stateId: 46,
    state: "Virginia",
    countryId: 0,
    country: "US",
  },
  {
    id: 789,
    dma: "Tucson(Sierra Vista)",
    stateCode: "AZ",
    stateId: 5,
    state: "Arizona",
    countryId: 0,
    country: "US",
  },
  {
    id: 671,
    dma: "Tulsa",
    stateCode: "OK",
    stateId: 37,
    state: "Oklahoma",
    countryId: 0,
    country: "US",
  },
  {
    id: 760,
    dma: "Twin Falls",
    stateCode: "ID",
    stateId: 14,
    state: "Idaho",
    countryId: 0,
    country: "US",
  },
  {
    id: 709,
    dma: "Tyler-Longview et al",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 526,
    dma: "Utica",
    stateCode: "NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 626,
    dma: "Victoria",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 548,
    dma: "W. Palm Beach et al",
    stateCode: "FL",
    stateId: 11,
    state: "Florida",
    countryId: 0,
    country: "US",
  },
  {
    id: 625,
    dma: "Waco-Temple-Bryan",
    stateCode: "TX",
    stateId: 44,
    state: "Texas",
    countryId: 0,
    country: "US",
  },
  {
    id: 511,
    dma: "Washington et al",
    stateCode: "DC-MD",
    stateId: 21,
    state: "Maryland",
    countryId: 0,
    country: "US",
  },
  {
    id: 549,
    dma: "Watertown",
    stateCode: "NY",
    stateId: 35,
    state: "New York",
    countryId: 0,
    country: "US",
  },
  {
    id: 705,
    dma: "Wausau-Rhinelander",
    stateCode: "WI",
    stateId: 49,
    state: "Wisconsin",
    countryId: 0,
    country: "US",
  },
  {
    id: 554,
    dma: "Wheeling et al",
    stateCode: "WV-OH",
    stateId: 36,
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 627,
    dma: "Wichita Fls et al",
    stateCode: "TX-OK",
    stateId: 37,
    state: "Oklahoma",
    countryId: 0,
    country: "US",
  },
  {
    id: 678,
    dma: "Wichita et al",
    stateCode: "KS",
    stateId: 17,
    state: "Kansas",
    countryId: 0,
    country: "US",
  },
  {
    id: 577,
    dma: "Wilkes Barre et al",
    stateCode: "PA",
    stateId: 39,
    state: "Pennsylvania",
    countryId: 0,
    country: "US",
  },
  {
    id: 550,
    dma: "Wilmington",
    stateCode: "NC",
    stateId: 28,
    state: "North Carolina",
    countryId: 0,
    country: "US",
  },
  {
    id: 810,
    dma: "Yakima et al",
    stateCode: "WA",
    stateId: 48,
    state: "Washington",
    countryId: 0,
    country: "US",
  },
  {
    id: 536,
    dma: "Youngstown",
    stateCode: "OH",
    stateId: 36,
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 771,
    dma: "Yuma-El Centro",
    stateCode: "AZ-CA",
    stateId: 6,
    state: "California",
    countryId: 0,
    country: "US",
  },
  {
    id: 596,
    dma: "Zanesville",
    stateCode: "OH",
    stateId: 36,
    state: "Ohio",
    countryId: 0,
    country: "US",
  },
  {
    id: 999,
    dma: null,
    code: null,
    state: null,
    countryId: null,
    country: null,
  },
]

export const regionCode = [
  {
    id: 0,
    name: "Midwest",
  },
  {
    id: 1,
    name: "Northeast",
  },
  {
    id: 2,
    name: "South",
  },
  {
    id: 3,
    name: "West",
  },
]

export const countryCode = [
  {
    id: 0,
    name: "US",
  },
]
